// import React, { useState, useEffect } from "react";
// import {
//   getStorage,
//   ref,
//   uploadBytesResumable,
//   getDownloadURL,
// } from "firebase/storage";
// import { doc, setDoc, getDoc } from "firebase/firestore";
// import Swal from "sweetalert2";
// import { db } from "../../../firebase"; // Імпорт Firebase конфігурації
// import css from "../adm.module.css"; // Заміна на ваш шлях до стилів

// export default function PriceOptPage() {
//   const [joinLink, setJoinLink] = useState("");
//   const [detailsLink, setDetailsLink] = useState("");
//   const [saleNewOneUrl, setSaleNewOneUrl] = useState("");
//   const [saleNewTwoUrl, setSaleNewTwoUrl] = useState("");
//   const [saleThreBlockUrl, setSaleThreBlockUrl] = useState("");
//   const [rotatePicUrl, setRotatePicUrl] = useState("");
//   const [notRotatePicUrl, setNotRotatePicUrl] = useState("");

//   const [saleNewOne, setSaleNewOne] = useState(null);
//   const [saleNewTwo, setSaleNewTwo] = useState(null);
//   const [saleThreBlock, setSaleThreBlock] = useState(null);
//   const [rotatePic, setRotatePic] = useState(null);
//   const [notRotatePic, setNotRotatePic] = useState(null);

//   useEffect(() => {
//     const loadData = async () => {
//       const docRef = doc(db, "pageOpt", "pageSettings");
//       const docSnap = await getDoc(docRef);

//       if (docSnap.exists()) {
//         const data = docSnap.data();
//         setJoinLink(data.joinLink || "");
//         setDetailsLink(data.detailsLink || "");
//         setSaleNewOneUrl(data.saleNewOneUrl || "");
//         setSaleNewTwoUrl(data.saleNewTwoUrl || "");
//         setSaleThreBlockUrl(data.saleThreBlockUrl || "");
//         setRotatePicUrl(data.rotatePicUrl || "");
//         setNotRotatePicUrl(data.notRotatePicUrl || "");
//       }
//     };

//     loadData();
//   }, []);

//   const handleFileUpload = (file, storagePath) => {
//     return new Promise((resolve, reject) => {
//       const storageRef = ref(getStorage(), storagePath);
//       const uploadTask = uploadBytesResumable(storageRef, file);

//       Swal.fire({
//         title: "Завантаження...",
//         html: "Прогрес: <b></b>%",
//         allowOutsideClick: false,
//         didOpen: () => {
//           Swal.showLoading();
//           uploadTask.on(
//             "state_changed",
//             (snapshot) => {
//               const progress =
//                 (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
//               Swal.getHtmlContainer().querySelector("b").textContent =
//                 Math.floor(progress);
//             },
//             (error) => {
//               console.log("Помилка під час завантаження:", error);
//               Swal.fire(
//                 "Помилка!",
//                 "Помилка під час завантаження фото.",
//                 "error"
//               );
//               reject(error);
//             },
//             async () => {
//               const downloadURL = await getDownloadURL(uploadTask.snapshot.ref);
//               Swal.fire("Успіх!", "Файл успішно завантажено!", "success");
//               resolve(downloadURL);
//             }
//           );
//         },
//       });
//     });
//   };

//   const handleSave = async () => {
//     try {
//       const docRef = doc(db, "pageOpt", "pageSettings");

//       let updatedData = {
//         joinLink,
//         detailsLink,
//         saleNewOneUrl,
//         saleNewTwoUrl,
//         saleThreBlockUrl,
//         rotatePicUrl,
//         notRotatePicUrl,
//       };

//       if (saleNewOne) {
//         const newSaleNewOneUrl = await handleFileUpload(
//           saleNewOne,
//           `images/saleNewOne`
//         );
//         updatedData.saleNewOneUrl = newSaleNewOneUrl;
//       }
//       if (saleNewTwo) {
//         const newSaleNewTwoUrl = await handleFileUpload(
//           saleNewTwo,
//           `images/saleNewTwo`
//         );
//         updatedData.saleNewTwoUrl = newSaleNewTwoUrl;
//       }
//       if (saleThreBlock) {
//         const newSaleThreBlockUrl = await handleFileUpload(
//           saleThreBlock,
//           `images/saleThreBlock`
//         );
//         updatedData.saleThreBlockUrl = newSaleThreBlockUrl;
//       }
//       if (rotatePic) {
//         const newRotatePicUrl = await handleFileUpload(
//           rotatePic,
//           `images/rotatePic`
//         );
//         updatedData.rotatePicUrl = newRotatePicUrl;
//       }
//       if (notRotatePic) {
//         const newNotRotatePicUrl = await handleFileUpload(
//           notRotatePic,
//           `images/notRotatePic`
//         );
//         updatedData.notRotatePicUrl = newNotRotatePicUrl;
//       }

//       await setDoc(docRef, updatedData, { merge: true });

//       Swal.fire("Успіх!", "Усі зміни успішно збережено!", "success");
//     } catch (error) {
//       Swal.fire(
//         "Помилка!",
//         "Сталася помилка під час збереження змін.",
//         "error"
//       );
//     }
//   };

//   return (
//     <div className={css.pageOptionsManager}>
//       <h2>Управління опціями сторінки</h2>
//       <div className={css.formGroup}>
//         <label>Посилання для кнопки "Приєднатися":</label>
//         <input
//           type="text"
//           value={joinLink}
//           onChange={(e) => setJoinLink(e.target.value)}
//         />
//       </div>
//       <div className={css.formGroup}>
//         <label>Посилання для кнопки "Детальніше":</label>
//         <input
//           type="text"
//           value={detailsLink}
//           onChange={(e) => setDetailsLink(e.target.value)}
//         />
//       </div>
//       <div className={css.formGroup}>
//         <label>Зображення "Акція до Нового року":</label>
//         {saleNewOneUrl && (
//           <img src={saleNewOneUrl} alt="Акція до Нового року" />
//         )}
//         <input type="file" onChange={(e) => setSaleNewOne(e.target.files[0])} />
//       </div>
//       <div className={css.formGroup}>
//         <label>Зображення "Знижка на товар":</label>
//         {saleNewTwoUrl && <img src={saleNewTwoUrl} alt="Знижка на товар" />}
//         <input type="file" onChange={(e) => setSaleNewTwo(e.target.files[0])} />
//       </div>
//       <div className={css.formGroup}>
//         <label>Зображення "Третій блок":</label>
//         {saleThreBlockUrl && <img src={saleThreBlockUrl} alt="Третій блок" />}
//         <input
//           type="file"
//           onChange={(e) => setSaleThreBlock(e.target.files[0])}
//         />
//       </div>
//       <div className={css.formGroup}>
//         <label>Зображення "Зображення з обертанням":</label>
//         {rotatePicUrl && (
//           <img src={rotatePicUrl} alt="Зображення з обертанням" />
//         )}
//         <input type="file" onChange={(e) => setRotatePic(e.target.files[0])} />
//       </div>
//       <div className={css.formGroup}>
//         <label>Зображення "Статичне зображення":</label>
//         {notRotatePicUrl && (
//           <img src={notRotatePicUrl} alt="Статичне зображення" />
//         )}
//         <input
//           type="file"
//           onChange={(e) => setNotRotatePic(e.target.files[0])}
//         />
//       </div>
//       <button onClick={handleSave} className={css.saveButton}>
//         Зберегти зміни
//       </button>
//     </div>
//   );
// }
import React, { useEffect, useState } from "react";
import {
  getStorage,
  ref,
  uploadBytesResumable,
  getDownloadURL,
} from "firebase/storage";
import { doc, setDoc, getDoc } from "firebase/firestore";
import Swal from "sweetalert2";
import { db } from "../../../firebase";
import css from "../adm.module.css";

const DEFAULT_FORM_DATA = {
  joinLink: "",
  detailsLink: "",

  leftTitle: "Акція до\nНового року",
  leftBadgeMainText: "+5",
  leftBadgeSmallText: "безкоштовно*",
  leftButtonText: "Приєднатися",
  leftBottomText: "*від 20 одиниць",

  rightTitle: "Розпродаж у зв'язку зі\nзняттям з виробництва",
  rightBadgeMainText: "-20%",
  rightBadgeSmallText: "знижка",
  rightButtonText: "Детальніше",
  rightBottomText: "до 29 вересня",

  saleNewOneUrl: "",
  saleNewTwoUrl: "",
  saleThreBlockUrl: "",
  rotatePicUrl: "",
  notRotatePicUrl: "",
};

export default function PriceOptPage() {
  const [formData, setFormData] = useState(DEFAULT_FORM_DATA);

  const [files, setFiles] = useState({
    saleNewOne: null,
    saleNewTwo: null,
    saleThreBlock: null,
    rotatePic: null,
    notRotatePic: null,
  });

  useEffect(() => {
    const loadData = async () => {
      const docRef = doc(db, "pageOpt", "pageSettings");
      const docSnap = await getDoc(docRef);

      if (docSnap.exists()) {
        setFormData({
          ...DEFAULT_FORM_DATA,
          ...docSnap.data(),
        });
      }
    };

    loadData();
  }, []);

  const updateField = (field, value) => {
    setFormData((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const updateFile = (field, file) => {
    setFiles((prev) => ({
      ...prev,
      [field]: file,
    }));
  };

  const handleFileUpload = (file, storagePath) => {
    return new Promise((resolve, reject) => {
      const storageRef = ref(getStorage(), storagePath);
      const uploadTask = uploadBytesResumable(storageRef, file);

      Swal.fire({
        title: "Завантаження...",
        html: "Прогрес: <b></b>%",
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();

          uploadTask.on(
            "state_changed",
            (snapshot) => {
              const progress =
                (snapshot.bytesTransferred / snapshot.totalBytes) * 100;

              Swal.getHtmlContainer().querySelector("b").textContent =
                Math.floor(progress);
            },
            (error) => {
              console.log("Помилка під час завантаження:", error);
              Swal.fire(
                "Помилка!",
                "Помилка під час завантаження фото.",
                "error",
              );
              reject(error);
            },
            async () => {
              const downloadURL = await getDownloadURL(uploadTask.snapshot.ref);
              resolve(downloadURL);
            },
          );
        },
      });
    });
  };

  const handleSave = async () => {
    try {
      const docRef = doc(db, "pageOpt", "pageSettings");

      const updatedData = {
        ...formData,
      };

      if (files.saleNewOne) {
        updatedData.saleNewOneUrl = await handleFileUpload(
          files.saleNewOne,
          "images/saleNewOne",
        );
      }

      if (files.saleNewTwo) {
        updatedData.saleNewTwoUrl = await handleFileUpload(
          files.saleNewTwo,
          "images/saleNewTwo",
        );
      }

      if (files.saleThreBlock) {
        updatedData.saleThreBlockUrl = await handleFileUpload(
          files.saleThreBlock,
          "images/saleThreBlock",
        );
      }

      if (files.rotatePic) {
        updatedData.rotatePicUrl = await handleFileUpload(
          files.rotatePic,
          "images/rotatePic",
        );
      }

      if (files.notRotatePic) {
        updatedData.notRotatePicUrl = await handleFileUpload(
          files.notRotatePic,
          "images/notRotatePic",
        );
      }

      await setDoc(docRef, updatedData, { merge: true });

      setFormData({
        ...DEFAULT_FORM_DATA,
        ...updatedData,
      });

      setFiles({
        saleNewOne: null,
        saleNewTwo: null,
        saleThreBlock: null,
        rotatePic: null,
        notRotatePic: null,
      });

      Swal.fire("Успіх!", "Усі зміни успішно збережено!", "success");
    } catch (error) {
      console.error("Помилка збереження налаштувань сторінки /opt:", error);

      Swal.fire(
        "Помилка!",
        "Сталася помилка під час збереження змін.",
        "error",
      );
    }
  };

  return (
    <div className={css.pageOptionsManager}>
      <h2>Прайс-гурт — Акції та розпродаж</h2>

      <h3>Лівий банер</h3>

      <div className={css.formGroup}>
        <label>Заголовок лівого банера:</label>
        <textarea
          value={formData.leftTitle}
          onChange={(e) => updateField("leftTitle", e.target.value)}
          rows={3}
        />
      </div>

      <div className={css.formGroup}>
        <label>Великий текст у жовтому ромбі:</label>
        <input
          type="text"
          value={formData.leftBadgeMainText}
          onChange={(e) => updateField("leftBadgeMainText", e.target.value)}
        />
      </div>

      <div className={css.formGroup}>
        <label>Малий текст у жовтому ромбі:</label>
        <input
          type="text"
          value={formData.leftBadgeSmallText}
          onChange={(e) => updateField("leftBadgeSmallText", e.target.value)}
        />
      </div>

      <div className={css.formGroup}>
        <label>Текст кнопки лівого банера:</label>
        <input
          type="text"
          value={formData.leftButtonText}
          onChange={(e) => updateField("leftButtonText", e.target.value)}
        />
      </div>

      <div className={css.formGroup}>
        <label>Посилання для кнопки лівого банера:</label>
        <input
          type="text"
          value={formData.joinLink}
          onChange={(e) => updateField("joinLink", e.target.value)}
        />
      </div>

      <div className={css.formGroup}>
        <label>Нижній текст лівого банера:</label>
        <input
          type="text"
          value={formData.leftBottomText}
          onChange={(e) => updateField("leftBottomText", e.target.value)}
        />
      </div>

      <div className={css.formGroup}>
        <label>Зображення 1 лівого банера:</label>
        {formData.saleNewOneUrl && (
          <img src={formData.saleNewOneUrl} alt="Зображення 1 лівого банера" />
        )}
        <input
          type="file"
          onChange={(e) => updateFile("saleNewOne", e.target.files[0])}
        />
      </div>

      <div className={css.formGroup}>
        <label>Зображення 2 лівого банера:</label>
        {formData.saleNewTwoUrl && (
          <img src={formData.saleNewTwoUrl} alt="Зображення 2 лівого банера" />
        )}
        <input
          type="file"
          onChange={(e) => updateFile("saleNewTwo", e.target.files[0])}
        />
      </div>

      <div className={css.formGroup}>
        <label>Зображення 3 лівого банера:</label>
        {formData.saleThreBlockUrl && (
          <img
            src={formData.saleThreBlockUrl}
            alt="Зображення 3 лівого банера"
          />
        )}
        <input
          type="file"
          onChange={(e) => updateFile("saleThreBlock", e.target.files[0])}
        />
      </div>

      <hr />

      <h3>Правий банер</h3>

      <div className={css.formGroup}>
        <label>Заголовок правого банера:</label>
        <textarea
          value={formData.rightTitle}
          onChange={(e) => updateField("rightTitle", e.target.value)}
          rows={3}
        />
      </div>

      <div className={css.formGroup}>
        <label>Великий текст у червоному ромбі:</label>
        <input
          type="text"
          value={formData.rightBadgeMainText}
          onChange={(e) => updateField("rightBadgeMainText", e.target.value)}
        />
      </div>

      <div className={css.formGroup}>
        <label>Малий текст у червоному ромбі:</label>
        <input
          type="text"
          value={formData.rightBadgeSmallText}
          onChange={(e) => updateField("rightBadgeSmallText", e.target.value)}
        />
      </div>

      <div className={css.formGroup}>
        <label>Текст кнопки правого банера:</label>
        <input
          type="text"
          value={formData.rightButtonText}
          onChange={(e) => updateField("rightButtonText", e.target.value)}
        />
      </div>

      <div className={css.formGroup}>
        <label>Посилання для кнопки правого банера:</label>
        <input
          type="text"
          value={formData.detailsLink}
          onChange={(e) => updateField("detailsLink", e.target.value)}
        />
      </div>

      <div className={css.formGroup}>
        <label>Нижній текст правого банера:</label>
        <input
          type="text"
          value={formData.rightBottomText}
          onChange={(e) => updateField("rightBottomText", e.target.value)}
        />
      </div>

      <div className={css.formGroup}>
        <label>Зображення 1 правого банера:</label>
        {formData.rotatePicUrl && (
          <img src={formData.rotatePicUrl} alt="Зображення 1 правого банера" />
        )}
        <input
          type="file"
          onChange={(e) => updateFile("rotatePic", e.target.files[0])}
        />
      </div>

      <div className={css.formGroup}>
        <label>Зображення 2 правого банера:</label>
        {formData.notRotatePicUrl && (
          <img
            src={formData.notRotatePicUrl}
            alt="Зображення 2 правого банера"
          />
        )}
        <input
          type="file"
          onChange={(e) => updateFile("notRotatePic", e.target.files[0])}
        />
      </div>

      <button onClick={handleSave} className={css.saveButton}>
        Зберегти зміни
      </button>
    </div>
  );
}